import { Component, OnInit } from "@angular/core";
import {
  DatoPaginadoModel,
  Paging,
} from "src/app/shared/models/dato-paginado.model";
import { FormGroup, FormBuilder, Validators, NgModel } from "@angular/forms";
import { RNTPrestadorEntry } from "src/app/shared/entrys/rnt-prestador.entry";
import { DatoSolicitudSharedModel } from "src/app/shared/models/dato-solicitud-shared.model";
import { PreguntaAdicionalEncuestaService } from "./pregunta-adicional-encuesta.service";
import { DataSharedService } from "src/app/shared/services/data-shared.service";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { ModalConfirmarRespuestaComponent } from "src/app/shared/layouts/modal-confirmar-respuesta/modal-confirmar-respuesta.component";
import {
  ConfirmarRespuestaModel,
  ConfirmarRespuestaType,
} from "src/app/shared/models/confirmar-respuesta.model";
import { CamaraComercioEntry } from "src/app/shared/entrys/camara-comercio";
import { AuthService } from "src/app/shared/services/auth.service";
import { RolesUsuario } from "src/app/shared/enumeraciones/roles-usuario.enum";
import { ConfirmeValidators } from "src/app/shared/directives/validators/confirme-validators";

import { ModalPreguntaListaValorComponent } from "src/app/components/core/layouts/modal-pregunta-lista-valor/modal-pregunta-lista-valor.component";
import { ModalPreguntaFormuladaComponent } from "src/app/components/core/layouts/modal-pregunta-formulada/modal-pregunta-formulada.component";
import { ModalPreguntaCondicionadaComponent } from "src/app/components/core/layouts/modal-pregunta-condicionada/modal-pregunta-condicionada.component";
import { ModalPreguntaCondicionBloqueoComponent } from "src/app/components/core/layouts/modal-pregunta-condicion-bloqueo/modal-pregunta-condicion-bloqueo.component";
import { ModalPreguntaEnlaceComponent } from "src/app/components/core/layouts/modal-pregunta-enlace/modal-pregunta-enlace.component";
import { TipoConfiguracionPregunta } from "src/app/shared/enumeraciones/tipo-configuracion-pregunta.enum";
import { ModalConfiguracionExtraPreguntaComponent } from "src/app/components/core/layouts/modal-configuracion-extra-pregunta/modal-configuracion-extra-pregunta.component";
import { TipoPregunta } from "src/app/shared/enumeraciones/tipo-pregunta.enum";
import { ModalPreguntaListaValorService } from "src/app/components/core/layouts/modal-pregunta-lista-valor/modal-pregunta-lista-valor.service";
import { debounceTime } from "rxjs/operators";

@Component({
  selector: "app-pregunta-adicional-encuesta",
  templateUrl: "./pregunta-adicional-encuesta.component.html",
  styleUrls: ["./pregunta-adicional-encuesta.component.scss"],
})
export class PreguntaAdicionalEncuestaComponent implements OnInit {
  dataTabla: DatoPaginadoModel;
  headerPreguntaAdicionalEncuesta: Array<string>;
  formPreguntaAdicionalEncuesta: FormGroup;
  selectPreguntaAdicionalEncuesta: any;

  paginaActual: number;
  // filtros
  filtro: FormGroup;
  public isCollapsed = true;
  // Selects
  camaraComercio: Array<any> = [];
  moduloEncuestaByAnioFiltro: Array<any> = [];
  seccionEncuestaByModuloFiltro: Array<any> = [];
  moduloEncuestaByAnio: Array<any> = [];
  seccionEncuestaByModulo: Array<any> = [];
  tipoValorLista: Array<{
    pregunta_tipo_valor_id: number;
    pregunta_tipo_valor_descripcion: string;
  }> = [];
  tipoPreguntaEncuesta: Array<any> = [];
  adminSuper = RolesUsuario.AdministradorSuper;
  tipo_pregunta_abierta = TipoPregunta.Abierta;
  tipo_pregunta_formula = TipoPregunta.Formula;
  tipo_pregunta_lista_valor = TipoPregunta.ListaValor;
  tipo_pregunta_multiple = TipoPregunta.Multiple;
  tipo_pregunta_unica = TipoPregunta.Unica;

  constructor(
    private formBuilder: FormBuilder,
    private preguntaAdicionalEncuestaService: PreguntaAdicionalEncuestaService,
    private modalService: NgbModal,
    public authService: AuthService,
    private modalPreguntaListaValorService: ModalPreguntaListaValorService
  ) {
    this.dataTabla = {
      paging: {} as Paging,
    } as DatoPaginadoModel;
    this.createForm();
    this.consultarListasFiltro();
    this.onConsultarTipoValorPregunta();
    this.onConsultarPreguntaAdicionalEncuesta(1);
    this.selectPreguntaAdicionalEncuesta = null;
    this.paginaActual = 1;
  }

  ngOnInit() {
    this.headerPreguntaAdicionalEncuesta = [
      "Cámara de Comercio",
      "Sección",
      "Año",
      "Tipo de Pregunta",
      "Descripción",
      "Tipo de Dato",
      "Longitud Mínima",
      "Longitud Máxima",
      "Obligatoria",
      "Orden",
      "Estado",
      "Acción",
      "Configuración",
    ];

    this.formPreguntaAdicionalEncuesta.get("anio").valueChanges.pipe(debounceTime(500)).subscribe(x => {
      if (x?.length) {
        this.preguntaAdicionalEncuestaService.getModuloEncuestaByAnio(x).subscribe(resultado => {
          if (resultado.data) {
            this.moduloEncuestaByAnio = resultado.data;
          }
        });
      } else {
        this.moduloEncuestaByAnio = [];
        this.seccionEncuestaByModulo = [];
      }
      this.formPreguntaAdicionalEncuesta.get("modulo_encuesta_id").patchValue(null);
      this.formPreguntaAdicionalEncuesta.get("seccion_encuesta_id").patchValue(null);
    });

    this.formPreguntaAdicionalEncuesta.get("modulo_encuesta_id").valueChanges.subscribe(x => {
      if (x) {
        this.preguntaAdicionalEncuestaService.getSeccionEncuestaByModulo(x).subscribe(resultado => {
          if (resultado.data) {
            this.seccionEncuestaByModulo = resultado.data;
          }
        });
      } else {
        this.seccionEncuestaByModulo = [];
      }
      this.formPreguntaAdicionalEncuesta.get("seccion_encuesta_id").patchValue(null);
    });
  }

  createForm() {
    this.formPreguntaAdicionalEncuesta = this.formBuilder.group({
      codigo_camara: [null, !this.authService.getRolUser(RolesUsuario.AdministradorSuper)
        ? ConfirmeValidators.validacionVacia : Validators.required],
      modulo_encuesta_id: [null, Validators.required],
      seccion_encuesta_id: [null, Validators.required],
      anio: [null, Validators.required],
      tipo_pregunta_encuesta_id: [null, Validators.required],
      descripcion: [null, Validators.required],
      pregunta_tipo_valor_id: [null],
      longitudGroup: this.formBuilder.group(
        {
          longitud_minima: [null, ConfirmeValidators.numberValidator],
          longitud_maxima: [null, ConfirmeValidators.numberValidator],
        },
        { validator: ConfirmeValidators.childrenNumberMaximo }
      ),
      con_prioridad: [null],
      es_obligatoria: [null, Validators.required],
      orden: [null, Validators.required],
      activo: [true],
    });

    this.filtro = this.formBuilder.group({
      codigo_camara: [null],
      modulo_encuesta_id: [null],
      seccion_encuesta_id: [null],
      anio: [null],
      tipo_pregunta_encuesta_id: [null],
      descripcion: [null],
      pregunta_tipo_valor_id: [null],
      longitud_minima: [null],
      longitud_maxima: [null],
      es_obligatoria: [null],
      orden: [null],
      activo: [null],
    });
  }

  cambioTipoPreguntaEncuesta(tipo_pregunta_id?: any, entry?: any) {
    if (!tipo_pregunta_id) {
      tipo_pregunta_id = this.formPreguntaAdicionalEncuesta.get(
        "tipo_pregunta_encuesta_id"
      ).value;
    }

    if (entry) {

      if (entry.anio) {
        this.preguntaAdicionalEncuestaService.getModuloEncuestaByAnio(entry.anio).subscribe(resultado => {
          if (resultado.data) {
            this.moduloEncuestaByAnio = resultado.data;
          }
        });
      }

      if (entry.modulo_encuesta_id) {
        this.preguntaAdicionalEncuestaService.getSeccionEncuestaByModulo(entry.modulo_encuesta_id).subscribe(resultado => {
          if (resultado.data) {
            this.seccionEncuestaByModulo = resultado.data;
          }
        });
      }

      this.formPreguntaAdicionalEncuesta
        .get("codigo_camara")
        .patchValue(entry.codigo_camara);

      this.formPreguntaAdicionalEncuesta
        .get("modulo_encuesta_id")
        .patchValue(entry.modulo_encuesta_id, {
          onlySelf: true, emitEvent: false
        });

      this.formPreguntaAdicionalEncuesta
        .get("seccion_encuesta_id")
        .patchValue(entry.seccion_encuesta_id, {
          onlySelf: true,
        });
      this.formPreguntaAdicionalEncuesta.get("anio").patchValue(entry.anio, { emitEvent: false });
      this.formPreguntaAdicionalEncuesta
        .get("descripcion")
        .patchValue(entry.descripcion);
      this.formPreguntaAdicionalEncuesta
        .get("pregunta_tipo_valor_id")
        .patchValue(entry.pregunta_tipo_valor_id, {
          onlySelf: true,
        });
      this.formPreguntaAdicionalEncuesta
        .get("longitudGroup")
        .get("longitud_minima")
        .patchValue(entry.longitud_minima);
      this.formPreguntaAdicionalEncuesta
        .get("longitudGroup")
        .get("longitud_maxima")
        .patchValue(entry.longitud_maxima);
      this.formPreguntaAdicionalEncuesta
        .get("es_obligatoria")
        .patchValue(entry.es_obligatoria);
      this.formPreguntaAdicionalEncuesta.get("orden").patchValue(entry.orden);
      this.formPreguntaAdicionalEncuesta
        .get("tipo_pregunta_encuesta_id")
        .patchValue(entry.tipo_pregunta_encuesta_id, {
          onlySelf: true,
        });
      this.formPreguntaAdicionalEncuesta.get("activo").patchValue(entry.activo);
      this.formPreguntaAdicionalEncuesta
        .get("con_prioridad")
        .patchValue(entry.con_prioridad);
    }

    if (tipo_pregunta_id == 1) {
      this.formPreguntaAdicionalEncuesta.get("con_prioridad").patchValue(null);
    } else if (tipo_pregunta_id == 2) {
      this.formPreguntaAdicionalEncuesta
        .get("pregunta_tipo_valor_id")
        .patchValue(null, {
          onlySelf: true,
        });
    } else if (tipo_pregunta_id == 4) {
      this.formPreguntaAdicionalEncuesta
        .get("pregunta_tipo_valor_id")
        .patchValue(null, {
          onlySelf: true,
        });
      this.formPreguntaAdicionalEncuesta
        .get("longitudGroup")
        .get("longitud_minima")
        .patchValue(null);
      this.formPreguntaAdicionalEncuesta
        .get("longitudGroup")
        .get("longitud_maxima")
        .patchValue(null);
      this.formPreguntaAdicionalEncuesta.get("con_prioridad").patchValue(null);
    } else {
      this.formPreguntaAdicionalEncuesta
        .get("pregunta_tipo_valor_id")
        .patchValue(null, {
          onlySelf: true,
        });
      this.formPreguntaAdicionalEncuesta
        .get("longitudGroup")
        .get("longitud_minima")
        .patchValue(null);
      this.formPreguntaAdicionalEncuesta
        .get("longitudGroup")
        .get("longitud_maxima")
        .patchValue(null);
      this.formPreguntaAdicionalEncuesta.get("con_prioridad").patchValue(null);
    }
  }

  onConsultarPreguntaAdicionalEncuesta(page: number) {
    this.preguntaAdicionalEncuestaService
      .get({
        ...this.filtro.value,
        numeroPagina: page,
        codigo_camara: this.authService.getRolUser(RolesUsuario.AdministradorCC)
          ? this.authService.getCamaraUser()
          : this.filtro.value.codigo_camara,
      })
      .subscribe((resultado) => {
        if (resultado.result) {
          this.dataTabla = resultado.data as DatoPaginadoModel;
        }
      });
  }

  onConsultarTipoValorPregunta() {
    this.preguntaAdicionalEncuestaService
      .getTipoValor()
      .subscribe((resultado) => {
        if (resultado.result) {
          this.tipoValorLista = resultado.data as Array<any>;
        }
      });
  }

  onPaginado(value: number) {
    this.paginaActual = value;
    this.onConsultarPreguntaAdicionalEncuesta(value);
  }

  onAgregarPreguntaAdicionalEncuesta() {
    this.preguntaAdicionalEncuestaService
      .create({
        ...this.formPreguntaAdicionalEncuesta.value,
        ...this.formPreguntaAdicionalEncuesta.value.longitudGroup,
        activo: 1,
        codigo_camara: this.authService.getRolUser(RolesUsuario.AdministradorCC)
          ? this.authService.getCamaraUser()
          : this.formPreguntaAdicionalEncuesta.value.codigo_camara,
      })
      .subscribe((resultado) => {
        if (resultado.result) {
          this.onConsultarPreguntaAdicionalEncuesta(this.paginaActual);
          this.formPreguntaAdicionalEncuesta.reset();
        }
      });
  }

  onOperarPreguntaAdicionalEncuesta() {
    if (!this.selectPreguntaAdicionalEncuesta) {
      this.onAgregarPreguntaAdicionalEncuesta();
    } else {
      this.onModificarPreguntaAdicionalEncuesta();
    }
  }

  onCargarPreguntaAdicionalEncuesta(entry: any) {
    this.cambioTipoPreguntaEncuesta(entry.tipo_pregunta_encuesta_id, entry);
    this.selectPreguntaAdicionalEncuesta = entry;
  }

  onEliminarPreguntaAdicionalEncuesta(entry: any) {
    const modalRef = this.modalService.open(ModalConfirmarRespuestaComponent, {
      centered: true,
    });
    const confirmarRespuesta = {} as ConfirmarRespuestaModel;
    confirmarRespuesta.type = ConfirmarRespuestaType.Atencion;
    confirmarRespuesta.message = `¿Está seguro de eliminar la configuración seleccionada?`;
    modalRef.componentInstance.confirmarRespuesta = confirmarRespuesta;
    modalRef.result.then(() => {
      this.preguntaAdicionalEncuestaService
        .delete(entry)
        .subscribe((resultado) => {
          if (resultado.result) {
            // tslint:disable-next-line:max-line-length
            const index = this.dataTabla.items
              .map(function (e) {
                return e.pregunta_adicional_encuesta_id;
              })
              .indexOf(entry.pregunta_adicional_encuesta_id);
            this.dataTabla.items.splice(index, 1);
            this.selectPreguntaAdicionalEncuesta = null;
            this.formPreguntaAdicionalEncuesta.reset();
          }
        });
    });
  }

  onModificarPreguntaAdicionalEncuesta() {
    this.preguntaAdicionalEncuestaService
      .update({
        ...this.formPreguntaAdicionalEncuesta.value,
        ...this.formPreguntaAdicionalEncuesta.value.longitudGroup,
        pregunta_adicional_encuesta_id: this.selectPreguntaAdicionalEncuesta
          .pregunta_adicional_encuesta_id,
        codigo_camara: this.authService.getRolUser(RolesUsuario.AdministradorCC)
          ? this.authService.getCamaraUser()
          : this.formPreguntaAdicionalEncuesta.value.codigo_camara,
      })
      .subscribe((resultado) => {
        if (resultado.result) {
          this.onConsultarPreguntaAdicionalEncuesta(this.paginaActual);
          this.formPreguntaAdicionalEncuesta.reset();
          this.selectPreguntaAdicionalEncuesta = null;
        }
      });
  }

  consultarListasFiltro() {
    this.filtro.get("anio").valueChanges.pipe(debounceTime(500)).subscribe(x => {
      if (x?.length) {
        this.preguntaAdicionalEncuestaService.getModuloEncuestaByAnio(x).subscribe(resultado => {
          if (resultado.data) {
            this.moduloEncuestaByAnioFiltro = resultado.data;
          }
        });
      } else {
        this.moduloEncuestaByAnioFiltro = [];
        this.seccionEncuestaByModuloFiltro = [];
      }
      this.filtro.get("modulo_encuesta_id").patchValue(null);
      this.filtro.get("seccion_encuesta_id").patchValue(null);
    });

    this.filtro.get("modulo_encuesta_id").valueChanges.subscribe(x => {
      if (x?.length) {
        this.preguntaAdicionalEncuestaService.getSeccionEncuestaByModulo(x).subscribe(resultado => {
          if (resultado.data) {
            this.seccionEncuestaByModuloFiltro = resultado.data;
          }
        });
      } else {
        this.seccionEncuestaByModuloFiltro = [];
      }
      this.filtro.get("seccion_encuesta_id").patchValue(null);
    });

    this.preguntaAdicionalEncuestaService
      .getCamaraComercio()
      .subscribe((resultado) => {
        if (resultado.data) {
          this.camaraComercio = resultado.data;
        }
        if (!this.authService.getRolUser(RolesUsuario.AdministradorSuper)) {
          this.formPreguntaAdicionalEncuesta
            .get("codigo_camara")
            .patchValue(this.authService.getCamaraUser());
        }
      });
    this.preguntaAdicionalEncuestaService
      .getTipoPreguntaEncuesta()
      .subscribe((resultado) => {
        if (resultado.data) {
          this.tipoPreguntaEncuesta = resultado.data;
        }
      });
  }

  filtrar() {
    this.paginaActual = 1;
    this.onConsultarPreguntaAdicionalEncuesta(1);
  }

  limpiar() {
    this.filtro.reset();
    this.filtrar();
  }

  limpiarRespuestaAdicionalEncuesta() {
    this.formPreguntaAdicionalEncuesta.reset();
    this.selectPreguntaAdicionalEncuesta = null;
    // this.createForm();
    if (!this.authService.getRolUser(RolesUsuario.AdministradorSuper)) {
      this.formPreguntaAdicionalEncuesta
        .get("codigo_camara")
        .patchValue(this.authService.getCamaraUser());
    }
  }

  onOpenModalListaValor(entry: any) {
    const isAditional = true;
    this.modalPreguntaListaValorService
      .getOrigenesValorLista()
      .subscribe((resultado1) => {
        if (resultado1.result) {
          this.modalPreguntaListaValorService
            .getPreguntaEncuestaAdministrador(entry.pregunta_adicional_encuesta_id, entry.seccion_encuesta_id,
              entry.orden, isAditional)
            .subscribe((resultado2) => {

              if (resultado2.result) {
                this.modalPreguntaListaValorService
                  .getPreguntaEncuesta(entry.pregunta_adicional_encuesta_id, isAditional)
                  .subscribe((resultado3) => {

                    if (resultado3.result) {
                      const modalRef = this.modalService.open(ModalPreguntaListaValorComponent, {
                        centered: true,
                        backdropClass: "light-blue-backdrop",
                        backdrop: "static",
                      });

                      modalRef.componentInstance.infoPregunta = entry;
                      modalRef.componentInstance.isAditional = isAditional;
                      modalRef.componentInstance.origenesValorLista = resultado1.data;
                      modalRef.componentInstance.preguntaOrigenLista = resultado2.data;
                      modalRef.componentInstance.data = resultado3.data ? resultado3.data[0] : null;

                      modalRef.result
                        .then((result) => {
                          if (result) {
                            if (!isNaN(result.form.pregunta_adicional_encuesta_id)) {
                              if (result.isEditing)
                                this.preguntaAdicionalEncuestaService
                                  .updateListaValor({
                                    ...result.form,
                                  })
                                  .subscribe((resultado) => console.log(resultado));
                              else
                                this.preguntaAdicionalEncuestaService
                                  .createListaValor({
                                    ...result.form,
                                  })
                                  .subscribe((resultado) => console.log(resultado));
                            }
                          }
                        })
                        .catch((error) => console.error(error));
                    }

                  });
              }

            });
        }
      });

  }

  onOpenModalPreguntaFormulada(entry: any) {
    const modalRef = this.modalService.open(
      ModalConfiguracionExtraPreguntaComponent,
      {
        centered: true,
        backdropClass: "light-blue-backdrop",
        backdrop: "static",
        size: "xl",
      }
    );

    modalRef.componentInstance.infoPregunta = entry;
    modalRef.componentInstance.clase_pregunta_id = 2;

    modalRef.componentInstance.infoPregunta = {
      ...entry,
      clase_pregunta_id: 2,
    };
    modalRef.componentInstance.pregunta_id =
      entry.pregunta_adicional_encuesta_id;
    modalRef.componentInstance.tipoConfiguracionPregunta =
      TipoConfiguracionPregunta.ConfiguracionFormula;

    modalRef.result
      .then((result) => {
        if (result)
          this.preguntaAdicionalEncuestaService
            .updatePreguntaFormuladaCondicionBloqueo({
              ...result,
              pregunta_encuesta_id: result.pregunta_id,
            })
            .subscribe((resultado) => console.log(resultado));
      })
      .catch((error) => console.error(error));
  }

  onOpenModalPreguntaCondicionada(entry: any) {
    const modalRef = this.modalService.open(
      ModalConfiguracionExtraPreguntaComponent,
      {
        centered: true,
        backdropClass: "light-blue-backdrop",
        backdrop: "static",
        size: "xl",
      }
    );

    modalRef.componentInstance.infoPregunta = {
      ...entry,
      clase_pregunta_id: 2,
    };
    modalRef.componentInstance.pregunta_id =
      entry.pregunta_adicional_encuesta_id;
    modalRef.componentInstance.tipoConfiguracionPregunta =
      TipoConfiguracionPregunta.ConfiguracionCondicion;

    modalRef.result
      .then((result) => {
        if (result) {
          if (result.isEditing)
            this.preguntaAdicionalEncuestaService
              .updatePreguntaCondicionada({
                ...result,
                pregunta_adicional_encuesta_id: result.pregunta_id,
              })
              .subscribe((resultado) => console.log(resultado));
          else
            this.preguntaAdicionalEncuestaService
              .crearPreguntaCondicionada({
                ...result,
                pregunta_adicional_encuesta_id: result.pregunta_id,
              })
              .subscribe((resultado) => console.log(resultado));
        }
      })
      .catch((error) => console.error(error));
  }

  onOpenModalPreguntaCondicionBloqueo(entry: any) {
    const modalRef = this.modalService.open(
      ModalConfiguracionExtraPreguntaComponent,
      {
        centered: true,
        backdropClass: "light-blue-backdrop",
        backdrop: "static",
        size: "xl",
      }
    );

    modalRef.componentInstance.infoPregunta = {
      ...entry,
      clase_pregunta_id: 2,
    };
    modalRef.componentInstance.pregunta_id =
      entry.pregunta_adicional_encuesta_id;
    modalRef.componentInstance.tipoConfiguracionPregunta =
      TipoConfiguracionPregunta.ConfiguracionCondicionBloqueo;

    modalRef.result
      .then((result) => {
        if (result)
          this.preguntaAdicionalEncuestaService
            .updatePreguntaFormuladaCondicionBloqueo({
              ...result,
              pregunta_encuesta_id: result.pregunta_id,
            })
            .subscribe((resultado) => console.log(resultado));
      })
      .catch((error) => console.error(error));
  }

  onOpenModalEnlace(entry: any) {
    const modalRef = this.modalService.open(ModalPreguntaEnlaceComponent, {
      centered: true,
      size: "lg",
      backdropClass: "light-blue-backdrop",
      backdrop: "static",
    });

    modalRef.componentInstance.infoPregunta = {
      ...entry,
      clase_pregunta_id: 2,
    };
    modalRef.result
      .then((result) => {
        if (result)
          this.preguntaAdicionalEncuestaService
            .createEnlazarPreguntas({ ...result })
            .subscribe((resultado) => console.log(resultado));
      })
      .catch((error) => console.error(error));
  }
}
